"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_RESET_REASON_LENGTH = void 0;
exports.MAX_RESET_REASON_LENGTH = 500;
